import { API } from "../../config";
import {
  ProfileUpdateTypes,
  RegisterTypes,
  VerifyTokenTypes,
} from "../../types";

export const register = async (data: RegisterTypes) => {
  const response = await API.post("/auth/register", data);
  return response.data;
};
export const forgotPassword = async (data: { email: string }) => {
  const response = await API.post("/auth/forgot-password", data);
  return response.data;
};

export const login = async (data: { email: string; password: string }) => {
  const response = await API.post("/auth/login", data);
  return response.data;
};
export const verifytoken = async (data: VerifyTokenTypes) => {
  const response = await API.post("/auth/verify-token", data);
  return response.data;
};
export const resendtoken = async (data: VerifyTokenTypes) => {
  const response = await API.post("/auth/resend-token", data);
  return response.data;
};
export const profileUpdate = async (data: ProfileUpdateTypes) => {
  const response = await API.post("/profile/update", data);
  return response.data;
};
export const deleteAccount = async (id: string | number | undefined) => {
  const response = await API.post(`/profile/${id}`);
  return response.data;
};
